import {
  instance1,
  instance2,
  SESSION_ID_EMR,
  BASE_URL_EMR,
  V1,
} from "App/constants"

import { makeStyles } from "@material-ui/core/styles"
import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants/theme"
import {
  convertDateToValidInput,
  getAge,
  isNull,
  oneMonthBeforeToday,
  today,
} from "App/utils/helpers"
import { LIST_URL_REGISTRASI } from "utils/registrations"
import { dateFormat, endOfDay, validUTC } from "utils/dates"
import moment from "moment"

export const deleteKunjunganRawatInapById = async (id) => {
  try {
    await instance2.post(
      LIST_URL_REGISTRASI.kunjungan_rawat_inap.delete_rawat_inap,
      {},
      {
        headers: {
          registration_id: id,
        },
      },
    )
    return {
      state: true,
      message: "Berhasil menghapus data",
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const RESET_STATE_KUNJUNGAN_RAWAT_INAP = {
  jenis_layanan_id: "",
  kelaskunjungan_id: "",
  patients_id: "",
  tanggal_selesai: "",
  date: today(true),
  nama_rm: "",
  gender: "",
  umur: "",
  nohp: "",
  phone_number: "",
  address_now: "",
  pekerjaan: "",
  penanggung: "",
  nik: "",
  norm: "",
  no_sep: "",
  jenis_layanan_print: "Rawat Inap",

  company_id: null,
  company_name: "Pilih Perusahaan",

  insurance_no: "",

  insurance_id: null,
  insurance_name: "Pilih Asuransi",

  norujukan: "",
  nokontrol: "",

  doctor_id: "",
  doctor_name: "Pilih Dokter",

  spec_id: "",
  spec_code: "",
  jenisrm: 2,

  label_bed: "Pilih Kelas Terlebih Dahulu",
  bed_id: "",
  kelas_bed: "",

  rencana_pulang: "",

  filter_kelas_id: "",

  kode_dpjp: "",
  kode_dpjp_nama: "",

  doctor_kodebridge: "",
  validasi_bpjs: true,
  cob: false,
  is_rawat_bersama:false,
  remark: "",

  cara_masuk: "other",
  cara_masuk_name: "Lain-lain",
}

export const RESET_STATE_FORM_FILTER = {
  type_search: 0,
  type_rm: 0,
  qword: "",
  first_date: oneMonthBeforeToday(true),
  finish_date: endOfDay(true),
  status: 0,
  is_cancel: 0,
  doctor: null,
  nama_ruang: "Pilih Ruang",
  id_ruang: null,
  is_rawat_bersama: null,
  doctor_name: "Pilih Dokter",
  pages: 1,
  limit: 10,
}

export const valueJenisRm = [
  {
    value: 1,
    label: "External",
  },
  {
    value: 2,
    label: "Internal",
  },
]

export const valueTypeSearch = [
  {
    label: "Semua",
    value: 0,
  },
  {
    label: "ID RM",
    value: 1,
  },
  {
    label: "ID Kunjungan",
    value: 7,
  },
  {
    label: "Nama",
    value: 2,
  },
  {
    label: "ID Tagihan",
    value: 3,
  },
  {
    label: "No Asuransi",
    value: 4,
  },
  {
    label: "No SEP",
    value: 5,
  },
  {
    label: "Created By",
    value: 6,
  },
]

export const getDataSelectRekamMedis = (row) => {
  return {
    patients_id: row?.id,
    nama_rm: row?.fullname,
    norm: row.norm,
    gender: row?.gender === 1 ? "Laki-laki" : "Perempuan",
    gender_print: row.gender,
    umur: getAge(dateFormat({ date: row?.date_ob, formatDate: 'YYYY-MM-DD' })),
    date_ob: row.date_ob,
    nohp: row?.mobile_phone_number,
    phone_number: row?.phone_number,
    address_now: row?.address_now,
    penanggung: row?.guarantor_name,
    pekerjaan: row?.pekerjaan_name,
    nik: row?.nik,

    company_id: row?.company_id,
    company_name: row?.company_name,
    insurance_no: row?.insurance_number,
    insurance_id: row?.insurance_id,
    insurance_name: row?.insurance_name,
  }
}

export const validation = (formData) => {
  if (isNull(formData.kelaskunjungan_id)) {
    return {
      state: false,
      message: "Kelas Kunjungan tidak boleh kosong",
    }
  } else if (isNull(formData.nohp)) {
    return {
      state: false,
      message: "NO HP tidak boleh kosong",
    }
  } else if (formData.company_id === "") {
    return {
      state: false,
      message: "Perusahaan tidak boleh kosong",
    }
  } else if (isNull(formData.cara_masuk)) {
    return {
      state: false,
      message: "Cara masuk tidak boleh kosong",
    }
  } else if (formData.insurance_name === "BPJS") {
    if (isNull(formData.insurance_no)) {
      return {
        state: false,
        message: "Jika BPJS, No Asuransi tidak boleh kosong",
      }
    } else {
      return {
        state: true,
      }
    }
  } else {
    return {
      state: true,
    }
  }
}

export const STYLE_MASTER_GUDANG_UTAMA = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
})

export const getByFilterKunjunganRawatInap = async (
  formFilter,
  pages,
  limit,
) => {
  try {
    const api = await instance2.get(
      LIST_URL_REGISTRASI.kunjungan_rawat_inap.list,
      {
        params: {
          type_search: formFilter.type_search,
          type_rm: formFilter.type_rm,
          qword: formFilter.qword,
          id_ruang: formFilter.id_ruang,
          first_date: validUTC(formFilter.first_date),
          finish_date: validUTC(formFilter.finish_date),
          status: formFilter.status,
          is_cancel: formFilter.is_cancel,
          id_doctor: formFilter.doctor === null ? "" : formFilter.doctor,
          is_rawat_bersama: formFilter.is_rawat_bersama,
          pages,
          limit,
        },
      },
    )
    const res = api.data
    return {
      state: true,
      data: res.body,
      meta: res?.meta,
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getByFilterKunjunganRawatInapExport = async (formFilter) => {
  try {
    const api = await instance2.get(
      LIST_URL_REGISTRASI.kunjungan_rawat_inap.export,
      {
        params: {
          type_search: formFilter.type_search,
          type_rm: formFilter.type_rm,
          qword: formFilter.qword,
          id_ruang: formFilter.id_ruang,
          first_date: validUTC(formFilter.first_date),
          finish_date: validUTC(formFilter.finish_date),
          status: formFilter.status,
          is_cancel: formFilter.is_cancel,
          id_doctor: formFilter.doctor === null ? "" : formFilter.doctor,
          is_rawat_bersama: formFilter.is_rawat_bersama,
        },
      },
    )
    const res = api.data
    return {
      state: true,
      data: res.body,
      meta: res?.meta,
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getBedByKelas = async (kelasId) => {
  try {
    if (!isNull(kelasId)) {
      const api = await instance2.get(
        LIST_URL_REGISTRASI.kunjungan_rawat_inap.bed,
        {
          headers: {
            kelas_id: kelasId,
          },
        },
      )
      const res = api.data
      return {
        state: true,
        data: res.body,
      }
    } else {
      return {
        state: true,
        data: [],
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getNoSPRI = async (from, to) => {
  try {
    const api = await instance1.post(
      `/bridging`,
      {
        session_id: SESSION_ID_EMR,
        valid_from: moment(from).format("YYYY-MM-DD"),
        valid_to: moment(to).format("YYYY-MM-DD"),
      },
      {
        headers: {
          method: "post",
          url: `${BASE_URL_EMR}/${V1}/emr/tidaklanjut-spri`,
        },
      },
    )

    const response = api.data.body
    if (parseInt(response.metadata.code) === 200) {
      return {
        state: true,
        data: isNull(response.response.list) ? [] : response.response.list,
      }
    } else {
      return {
        state: false,
        data: response.metadata.message,
      }
    }
  } catch (error) {}
}

export const getNoKartu = async (nomor_kartu) => {
  try {
    const api = await instance1.post(
      `/bridging`,
      {
        session_id: SESSION_ID_EMR,
        nomor_kartu,
      },
      {
        headers: {
          method: "post",
          url: `${BASE_URL_EMR}/${V1}/emr/bridging/rujukan/pcare/no-kartu`,
        },
      },
    )

    const data = []
    const response = api.data.body
    if (parseInt(response.metadata.code) === 200) {
      data.push(response.response)
      return {
        state: true,
        data: data,
      }
    } else {
      return {
        state: false,
        data: response.metadata.message,
      }
    }
  } catch (error) {}
}

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID KUNJUNGAN",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "idrm",
    disablePadding: false,
    label: "ID RM",
    align: "left",
    minWidth: "120px",
    sort: false,
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA RM",
    align: "left",
    minWidth: "175px",
  },
  {
    id: "tagihan_id",
    disablePadding: false,
    label: "ID TAGIHAN",
    align: "left",
    minWidth: "120px",
  },
  {
    id: "nama_kelas_kunjungan",
    disablePadding: false,
    label: "KLS KUNJUNGAN",
    align: "left",
  },
  {
    id: "date",
    disablePadding: false,
    label: "TGL REGISTRASI",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "tanggal_selesai",
    disablePadding: false,
    label: "TGL SELESAI",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "iscancel",
    disablePadding: false,
    label: "STATUS",
    align: "center",
    minWidth: "110px",
  },
  {
    id: "is_rawat_bersama",
    disablePadding: false,
    label: "Rawat Bersama",
    align: "center",
    minWidth: "140px",
  },
  {
    id: "nohp",
    disablePadding: false,
    label: "NO HP",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "rm_phone_number",
    disablePadding: false,
    label: "NO TLP",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "doctor_fullname",
    disablePadding: false,
    label: "DOKTER",
    align: "left",
    minWidth: "180px",
  },

  {
    id: "company_name",
    disablePadding: false,
    label: "PERUSAHAAN",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "insurance_name",
    disablePadding: false,
    label: "ASURANSI",
    align: "left",
    minWidth: "150px",
    sort: false,
  },
  {
    id: "insurance_no",
    disablePadding: false,
    label: "NO ASURANSI",
    align: "left",
    minWidth: "150px",
    sort: false,
  },
  {
    id: "nosep",
    disablePadding: false,
    label: "NO SEP",
    align: "left",
    minWidth: "150px",
    sort: false,
  },
  {
    id: "date_ob",
    disablePadding: false,
    label: "TANGGAL LAHIR",
    align: "left",
    sort: false,
    minWidth: "140px",
  },
  {
    id: "umur",
    disablePadding: false,
    label: "UMUR",
    align: "left",
    sort: false,
    minWidth: "125px",
  },
  {
    id: "bed_name",
    disablePadding: false,
    label: "BED",
    align: "left",
    sort: false,
    minWidth: "135px",
  },
  {
    id: "bed_ruang_name",
    disablePadding: false,
    label: "RUANG",
    align: "left",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "nama_ppk_perujuk",
    disablePadding: false,
    label: "PPK PERUJUK",
    align: "left",
    sort: false,
    minWidth: "140px",
  },
  {
    id: "nama_hak_kelas",
    disablePadding: false,
    label: "HAK KELAS BPJS",
    align: "left",
    sort: false,
    minWidth: "140px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "CATATAN",
    align: "left",
    sort: false,
    minWidth: "250px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
]
